export const mobile = 375;
export const tablet = 750;
export const tabletLarge = 990;
export const desktopSmall = 1280;
export const desktop = 1440;
export const desktopFull = 1920;

export const isSmallMobile = () => window.innerWidth < mobile;
export const isMobile = () => window.innerWidth < tablet;
export const isTablet = () => window.innerWidth >= tablet && window.innerWidth < tabletLarge;
export const isTabletLarge = () => window.innerWidth >= tabletLarge && window.innerWidth < desktopSmall;
export const isDesktopSmall = () => window.innerWidth >= desktopSmall && window.innerWidth < desktop;
export const isDesktop = () => window.innerWidth >= desktop && window.innerWidth < desktopFull;
export const isDesktopFull = () => window.innerWidth >= desktopFull;

export const isLargerThanMobile = () => window.innerWidth >= mobile;
export const isLargerThanTablet = () => window.innerWidth >= tablet;
export const isLargerThanTabletLarge = () => window.innerWidth >= tabletLarge;
export const isLargerThanDesktopSmall = () => window.innerWidth >= desktopSmall;
export const isLargerThanDesktop = () => window.innerWidth >= desktop;
